<script setup lang="ts">
    import PauseStartImage from '~/assets/icons/play.svg';
    import PauseStopImage from '~/assets/icons/pause.svg';

    const props = defineProps<{ blok: AVideoComponentStoryblok }>();

    const fileType = String(props.blok.video.filename).split('.').pop();

    const videoRef = ref<HTMLVideoElement | null>(null);
    const isVideoPaused = ref(false);
    const customAspectRatio = ref(`--aspect-ratio-${props.blok.aspectRatio}`);

    const videoClasses = computed(() => {
        if (props.blok.externalVideoUrl) return [];

        const aspectRatio = props.blok.aspectRatio ? customAspectRatio.value : '';
        const customPause = props.blok.autoplay ? '--custom-pause' : '';

        return [aspectRatio, customPause].filter(Boolean); // Removes any empty strings
    });

    const pauseVideo = () => {
        if (!videoRef.value) return;

        if (sessionStorage.getItem(`paused${props.blok.video.filename}`) === 'true') {
            videoRef.value.play();
            sessionStorage.setItem(`paused${props.blok.video.filename}`, 'false');
            isVideoPaused.value = false;
        } else {
            videoRef.value.pause();
            sessionStorage.setItem(`paused${props.blok.video.filename}`, 'true');
            isVideoPaused.value = true;
        }
    };
</script>
<template>
    <div
        class="video"
        :class="videoClasses"
    >
        <video
            v-if="blok.video.filename"
            ref="videoRef"
            :autoplay="blok.autoplay"
            :muted="blok.autoplay"
            :loop="blok.autoplay || blok.loop"
            :controls="!blok.autoplay"
            playsinline
            :preload="blok.thumbnail?.filename ? 'none' : 'metadata'"
            :poster="blok.thumbnail?.filename ? `${blok.thumbnail.filename}/m/1000x0/filters:quality(75)` : undefined"
        >
            <source
                :src="
                    !blok.thumbnail?.id ? blok.video.filename + '#t=1' : blok.video.filename + '#t=' + blok.videoStart
                "
                :type="'video/' + fileType"
            />
        </video>

        <button
            v-if="blok.autoplay && !blok.externalVideoUrl"
            class="pause"
            @click="pauseVideo"
        >
            <div>
                <img
                    :src="isVideoPaused ? PauseStartImage : PauseStopImage"
                    :alt="isVideoPaused ? 'Video starten ' : 'Video pausieren'"
                    :class="{ paused: isVideoPaused }"
                />
            </div>
        </button>

        <ExternalVideo
            v-if="blok.externalVideoUrl"
            :src="blok.externalVideoUrl"
            :aspect-ratio="blok.aspectRatio"
        />
    </div>
</template>

<style scoped lang="scss">
    @import '~/assets/scss/video/video.scss';
</style>
